import React, { PureComponent } from 'react'

import './progressLine.scss'

class ProgressLine extends PureComponent {
  getFill () {
    let fill = typeof this.props.fill === 'string' ? parseInt(this.props.fill) : this.props.fill
    if (fill < 1) return ''
    return fill
  }

  getColor () {
    switch (this.props.color) {
      case 'green':
        return ' green'
      case 'red':
        return ' red'
      case 'yellow':
        return ' yellow'
      default:
        return ''
    }
  }

  render () {
    return (
      <div className={'element-progress-line' + this.getColor()} style={this.props.style} />
    )
  }
}

ProgressLine.defaultProps = {
  fill: 100,
  color: 'green'
}

export default ProgressLine



// WEBPACK FOOTER //
// ./src/app/shared/elements/progressLine/index.js